import { render } from "./AppUsersList.vue?vue&type=template&id=ed392b9c"
import script from "./AppUsersList.vue?vue&type=script&lang=js"
export * from "./AppUsersList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__